import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  GET_BOAT_CARD_INFO,
  GET_DATA_BY_SEARCH_PARAMS_BOAT,
  ADD_NEW_BOAT_INFO,
  EDIT_BOAT_INFO,
  UPDATE_BOAT_INFO,
  UPDATE_BOAT_INFO_FOR_ID,
  GET_CHECK_BOAT_SERIAL_NUMBER,
  UPDATE_BOAT_INFO_API,
  CHANGE_BOAT_INFO,
  REMOVE_ARREST_BOAT_INFO,
  DELETE_BOAT_FILE,
  CLEAR_BOAT_INFO,
  SET_SEARCH_PARAMS_BOATS,
  SET_PAGE_INDEX_BOATS,
  UPDATE_BOAT_INFO_FOR_ID_DEALS,
} from "../types";
import {
  MAIN_URL,
  PORT,
  API_GET_BOATS_LIST_SEARCH,
  API_GET_BOAT_INFO_CARD,
  API_GET_BOAT_INFO_SPEC_MARKS,
  API_DELETE_BOAT_INFO_DOCS,
  API_GET_BOAT_INFO_BY_VIN,
  API_UPDATE_BOAT_INFO_API,
} from "../../constants/constants";

const revertDate = (data) => {
  for (let item in data.data) {
    const reg = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    data.data[item] = reg.test(data.data[item])
      ? data.data[item].split("-").reverse().join(".")
      : data.data[item];
  }
  return data;
};

export function getBoatCardInfo(id) {
  return async (dispatch) => {
    let jsonData = {};
    if (id !== "") {
      const response = await fetchWithToken(MAIN_URL + PORT + API_GET_BOAT_INFO_CARD + String(id));
      jsonData = await response.json();
      const specMarksReq = await fetchWithToken(MAIN_URL + PORT + API_GET_BOAT_INFO_SPEC_MARKS + String(id));
      const specMarks = await specMarksReq.json();
      jsonData.specMarks = specMarks;
      jsonData.boatDeals = jsonData.boatDeals || [];
    }
    dispatch({
      type: GET_BOAT_CARD_INFO,
      data: jsonData,
    });
  };
}

export function updateBoatInfo(data) {
  const newData = revertDate(data);
  return {
    type: UPDATE_BOAT_INFO,
    data: newData,
  };
}

export function updateBoatInfoForId(data) {
  return {
    type: UPDATE_BOAT_INFO_FOR_ID,
    data,
  };
}

export function updateBoatInfoForIdDeals(data) {
  return {
    type: UPDATE_BOAT_INFO_FOR_ID_DEALS,
    data,
  };
}

export function getCheckBoatSerialNumber(data) {
  return async (dispatch) => {
    let response;
    const req = await fetchWithToken(MAIN_URL + PORT + API_GET_BOAT_INFO_BY_VIN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ boatName: data.boatName, boatVin: data.boatVin, boatType: data.boatTypeId }),
    });
    if (req.ok) {
      response = "success";
    } else {
      response = JSON.parse(await req.text());
    }
    dispatch({
      type: GET_CHECK_BOAT_SERIAL_NUMBER,
      data: { response, data },
    });
  };
}

export function updateBoatInfoApi(id, data, mainInformationForm) {
  const deleteLocalIdSpecMarks = data.boatCardSpecmarksDtoList.map((item) => {
    if (typeof item.id === "string") {
      delete item.id;
      return item;
    }
    return item;
  });
  const formData = new FormData();
  if (data.fileList?.length > 0) {
    for (let item of data.fileList) {
      formData.append("file", item);
    }
  }

  delete data.fileList;
  data.additionalInformation = [
    { note: mainInformationForm.note || null, note2: mainInformationForm.note2 || null },
  ];
  delete mainInformationForm.note;
  delete mainInformationForm.note2;
  data.mainInformation = {
    ...data.mainInformation,
    ...mainInformationForm,
    regNum: data.mainInformation.regNum,
  };
  data.boatCardSpecmarksDtoList = deleteLocalIdSpecMarks;

  return;
  formData.append("data", JSON.stringify(data));
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_UPDATE_BOAT_INFO_API + id, {
      method: "POST",
      body: formData,
    });
    if (request.ok) {
      dispatch({
        type: UPDATE_BOAT_INFO_API,
        data: "success",
      });
    } else {
      dispatch({
        type: UPDATE_BOAT_INFO_API,
        data: "error",
      });
    }
  };
}

export function getDataBoatsBySearchParams(params) {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_GET_BOATS_LIST_SEARCH, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    });
    const data = await response.json();
    for (let item of data) {
      const owner = `${item.ownerSurname} ${item.ownerName} ${item.ownerMidname}`;
      item["owner"] = owner;
    }
    const jsonData = data;

    dispatch({
      type: GET_DATA_BY_SEARCH_PARAMS_BOAT,
      data: jsonData,
    });
  };
}

export function addNewBoatInfo(data) {
  const newData = data.key === "documents" ? data : revertDate(data);
  return {
    type: ADD_NEW_BOAT_INFO,
    data: newData,
  };
}

export function editBoatInfo(data) {
  const newData = revertDate(data);
  return {
    type: data.key === "boatArrestsDtos" ? REMOVE_ARREST_BOAT_INFO : CHANGE_BOAT_INFO,
    data: newData,
  };
}

export function deleteBoatInfo(cardid, signature, fileName, tableType) {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_DELETE_BOAT_INFO_DOCS + cardid + `/${signature}/${encodeURI(fileName)}`,
      {
        method: "POST",
      },
    );
    const newData = { newInfo: await response.json(), tableType: tableType };
    dispatch({
      type: EDIT_BOAT_INFO,
      data: newData,
    });
  };
}

export function deleteBoatFile(data) {
  return {
    type: DELETE_BOAT_FILE,
    data,
  };
}

export function clearBoatInfo() {
  return {
    type: CLEAR_BOAT_INFO,
  };
}

export function setSearchParamsBoats(params) {
  return {
    type: SET_SEARCH_PARAMS_BOATS,
    data: params,
  };
}

export function setPageIndexBoats(index) {
  return {
    type: SET_PAGE_INDEX_BOATS,
    data: index,
  };
}
